import { RegisterCard } from '@/components/register-card/register-card';
import SEOHelmet from '@/components/SEOHelmet/SEOHelmet';
import { amplitudeAddTrack, determineProjectName } from '@/utils/amplitud/event-track';
import React, { useEffect, useRef } from 'react';

const CompleteProfilePage: React.FC = () => {

    const firstRenderAmplitude = useRef<boolean>(true);
    useEffect(() => {
        if (firstRenderAmplitude.current) {
            firstRenderAmplitude.current = false;
            amplitudeAddTrack(determineProjectName(`Completar perfil`), {
                title: determineProjectName(`Completar perfil`),
            })
        }
    }, []);

    return (
        <div>
            <SEOHelmet
                metadata={{
                    title: determineProjectName(`Completar perfil`),
                    description: determineProjectName(`Completar perfil`)
                }}
            />
            <RegisterCard />
        </div>
    );
};

export default CompleteProfilePage;